// src/analytics/events.js
import { track } from './ga4';

export const trackPageView = ({ page_path, page_title }) =>
  track('web_page_view', { page_path, page_title });

export const trackSectionView = ({ section }) =>
  track('web_section_view', { section });

export const trackScrollDepth = ({ percent }) =>
  track('web_scroll_depth', { percent });

export const trackTimeOnPage = ({ seconds }) =>
  track('web_time_on_page', { seconds });

export const trackLangSwitch = ({ from, to }) =>
  track('web_lang_switch', { from, to });

export const trackCtaStoreClick = ({ store, location }) =>
  track('web_cta_store_click', { store, location });

export const trackPhoneClick = ({ location }) =>
  track('web_phone_click', { location });

export const trackEmailClick = ({ location }) =>
  track('web_email_click', { location });

export const trackNavClick = ({ target, location }) =>
  track('web_nav_click', { target, location });

export const trackFaqExpand = ({ question_id }) =>
  track('web_faq_expand', { question_id });

export const trackChypreBannerClick = () =>
  track('web_chypre_banner_click');

export const trackChyprePageView = () =>
  track('web_chypre_page_view');

export const trackDriverShowcaseView = () =>
  track('web_driver_showcase_view');

export const trackDriverLoginAttempt = ({ success }) =>
  track('web_driver_login_attempt', { success });

export const trackMobileRedirect = ({ referrer }) =>
  track('web_mobile_redirect', { referrer });

export const trackConsentChoice = ({ choice }) =>
  track('web_consent_choice', { choice });

export const trackJsError = ({ message, source, lineno }) =>
  track('web_js_error', { message, source, lineno });
